export default __webpack_public_path__ + "static/media/pdfNextPage.b2905b4d.svg";